import { computed, type MaybeRefOrGetter, toValue } from "vue";
import { useThemeStore } from "#/store/theme";

const getVideoMimeType = (url: string | null) => (url?.includes(".mp4") ? "video/mp4" : "video/webm");

export const useScreenBackground = (isKiosk: MaybeRefOrGetter<boolean>) => {
	const themeStore = useThemeStore();

	const successUrl = computed(() => (toValue(isKiosk) ? themeStore.data?.kiosk_successful_order_screen_background || null : null));
	const preloaderUrl = computed(() => themeStore.data?.kiosk_preloader || null);

	const mediaUrl = computed(() => successUrl.value || preloaderUrl.value);
	const videoMimeType = computed(() => getVideoMimeType(mediaUrl.value));
	const isImage = computed(() => !!successUrl.value && themeStore.data?.kiosk_successful_order_screen_background_media_type === "image");

	return { mediaUrl, videoMimeType, isImage };
};
